import * as Yup from 'yup';

export default () =>
  Yup.object().shape({
    email: Yup.string().email('Invalid email format').required('Email field is required'),
    password: Yup.string().required('Password field is required'),
  });
